export default __webpack_public_path__ + "static/img6-06a7d2e2e90051654fe722f54b079a5e.webp";